<template>
  <div class="specification-area">
    <div class="one-specification">
      <div class="one-specification__title">
        {{ item.name }}
      </div>

      <ul class="one-specification__option">
        <li
          class="square-radio"
          v-for="(spec, index) in item.specs"
          :key="index"
        >
          <input
            type="radio"
            v-model="result"
            :value="spec.spec_id"
            :id="`the-${spec.spec_id}`"
          />
          <label :for="`the-${spec.spec_id}`">{{ spec.name }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    item: {
      required: true,
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>
